import { TimeAndDate } from '@zap-onboard/api-client';
import { LocalStorageStore } from './LocalStorageStore';

export const SuperAPISetupStore = new LocalStorageStore<{
  [businessId: string]: {
    hiddenAt?: TimeAndDate;
  };
}>(
  'SUPERAPI_SETUP',
  (v) => JSON.stringify(v),
  (v) => {
    const value = JSON.parse(v);
    return Object.fromEntries(
      Object.entries(value).map(([businessId, value]) => {
        const { hiddenAt } = value as { hiddenAt?: string };
        return [
          businessId,
          {
            hiddenAt: hiddenAt ? TimeAndDate.fromJSON(hiddenAt) : undefined,
          },
        ];
      }),
    );
  },
);
